import clsx from 'clsx';
import React, { memo } from 'react';
import { MuiCheckbox } from '../material-ui';
import useStyles from './StyledCheckbox.styles';

const StyledCheckbox = ({ theme, checked, className: overrideClassName, ...props }: any) => {
  const classes = useStyles({});
  const rootClassName = clsx(classes.root, `${theme}-theme`, overrideClassName);

  return (
    <MuiCheckbox
      checked={checked}
      className={rootClassName}
      data-testid="qa-styleCheckbox"
      disableRipple
      color="default"
      checkedIcon={<span className={classes.checkedIcon} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
};

export default memo(StyledCheckbox, (prevProps: any, nextProps: any) => {
  return prevProps.checked === nextProps.cheked;
});
